module.exports = __webpack_public_path__ + "img/8.bcaacd97.jpg";